// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.CoreIcon = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CoreIcon = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var CoreIcon = _exports.CoreIcon = function CoreIcon(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14223)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.88456 15.0704C12.9943 15.0704 15.5152 12.5495 15.5152 9.43973C15.5152 6.33001 12.9943 3.80908 9.88456 3.80908C6.77484 3.80908 4.25391 6.33001 4.25391 9.43973C4.25391 12.5495 6.77484 15.0704 9.88456 15.0704Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.5439 7.89002C19.0492 7.89002 19.4589 7.48037 19.4589 6.97504C19.4589 6.46971 19.0492 6.06006 18.5439 6.06006C18.0386 6.06006 17.6289 6.46971 17.6289 6.97504C17.6289 7.48037 18.0386 7.89002 18.5439 7.89002Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.7986 9.43896C18.7986 10.8451 18.4658 12.2313 17.8274 13.4843C17.189 14.7372 16.2631 15.8212 15.1255 16.6477C13.9879 17.4742 12.6708 18.0198 11.282 18.2398C9.8931 18.4597 8.86274 18.4559 7.52539 18.0214",
      stroke: "currentColor",
      "stroke-width": "0.78125",
      "stroke-linecap": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.64184 17.2622C4.40735 16.5923 3.3489 15.6399 2.55305 14.4826C1.75719 13.3253 1.24653 11.9962 1.0628 10.6037C0.879078 9.21128 1.02751 7.79513 1.49596 6.47105C1.96441 5.14697 2.73959 3.95256 3.7581 2.98547",
      stroke: "currentColor",
      "stroke-width": "0.78125",
      "stroke-linecap": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.2339 1.85238C6.43122 1.11818 7.78532 0.677784 9.18546 0.567187C10.5856 0.45659 11.992 0.678935 13.2898 1.21604C14.5875 1.75315 15.7397 2.58978 16.6522 3.65751C17.5647 4.72524 18.2115 5.99377 18.5397 7.35937",
      stroke: "currentColor",
      "stroke-width": "0.78125",
      "stroke-linecap": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.7473 19.7099C9.64758 19.7099 10.3774 18.9801 10.3774 18.0798C10.3774 17.1795 9.64758 16.4497 8.7473 16.4497C7.84701 16.4497 7.11719 17.1795 7.11719 18.0798C7.11719 18.9801 7.84701 19.7099 8.7473 19.7099Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.78125",
      "stroke-linecap": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.0618 7.83395C18.962 7.83395 19.6919 7.10413 19.6919 6.20384C19.6919 5.30356 18.962 4.57373 18.0618 4.57373C17.1615 4.57373 16.4316 5.30356 16.4316 6.20384C16.4316 7.10413 17.1615 7.83395 18.0618 7.83395Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.78125",
      "stroke-linecap": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.80784 5.73727C3.70813 5.73727 4.43795 5.00745 4.43795 4.10716C4.43795 3.20688 3.70813 2.47705 2.80784 2.47705C1.90756 2.47705 1.17773 3.20688 1.17773 4.10716C1.17773 5.00745 1.90756 5.73727 2.80784 5.73727Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.78125",
      "stroke-linecap": "round"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14223"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
